import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./linkRenderer.html";
const EMAIL_REGEX = /\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}\b/;
const HTTP_LINK_REGEX = /(http|https):\/\/\S+/gi;
class LinkRenderer extends LightningElement {
  constructor(...args) {
    super(...args);
    this.plainText = '';
    this.linkTarget = '_blank';
  }
  /**
   * Generates rendered elements based on the plain text.
   * Each rendered element represents a word or a group of words with optional links as spans or a links.
   */
  get renderedElements() {
    const words = this.plainText.split(' ');
    const result = [];
    let previousElementHasLink = false;
    for (const word of words) {
      if (this.isHttpLink(word)) {
        // If the word is an HTTP link
        const renderedElement = {
          text: word,
          link: word
        };
        if (!previousElementHasLink) {
          // Add a space before the link if it's not the first element with a link
          const element = result[result.length - 1];
          if (element) {
            element.text += ' ';
          }
        }
        result.push(renderedElement);
        previousElementHasLink = true;
      } else if (this.isEmailAddress(word)) {
        // If the word is an email address
        const renderedElement = {
          text: word,
          link: `mailto:${word}`
        };
        if (!previousElementHasLink) {
          // Add a space before the link if it's not the first element with a link
          const element = result[result.length - 1];
          if (element) {
            element.text += ' ';
          }
        }
        result.push(renderedElement);
        previousElementHasLink = true;
      } else {
        // If the word is neither a link nor an email address
        const renderedElement = {
          text: word,
          link: undefined
        };
        if (result.length > 0 && !previousElementHasLink) {
          // Concatenate the word to the previous element's text if it doesn't have a link
          const element = result[result.length - 1];
          if (element) {
            element.text += ` ${word}`;
          }
        } else {
          // Otherwise, create a new element with the word
          renderedElement.text = `${previousElementHasLink ? ' ' : ''}${word}`;
          result.push(renderedElement);
        }
        previousElementHasLink = false;
      }
    }
    return result;
  }
  isHttpLink(word) {
    return HTTP_LINK_REGEX.test(word);
  }
  isEmailAddress(word) {
    return EMAIL_REGEX.test(word);
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(LinkRenderer, {
  publicProps: {
    plainText: {
      config: 0
    },
    linkTarget: {
      config: 0
    }
  }
});
const __lwc_component_class_internal = _registerComponent(LinkRenderer, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;